import { createReducer } from 'redux-act';

import {
  WEB_PAGES_FETCH,
  WEB_PAGES_FETCH_DATA_SUCCESS,
  WEB_PAGES_FETCH_DATA_FAIL,
  WEB_PAGES_DELETE_INIT,
  WEB_PAGES_DELETE_SUCCESS,
  WEB_PAGES_DELETE_FAIL,
  WEB_PAGES_CLEAR_DATA,
  WEB_PAGES_CREATE_INIT,
  WEB_PAGES_CREATE_SUCCESS,
  WEB_PAGES_CREATE_FAIL,
  WEB_PAGES_MODIFY_INIT,
  WEB_PAGES_MODIFY_SUCCESS,
  WEB_PAGES_MODIFY_FAIL,
  WEB_PAGES_CLEAN_UP,
  WEB_PAGES_CLEAR_DATA_LOGOUT,
  SET_WEB_PAGES,
} from 'state/actions/webPages';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const webPagesReducer = createReducer(
  {
    [WEB_PAGES_FETCH]: () => ({
      ...initialState,
      loading: true,
    }),
    [WEB_PAGES_FETCH_DATA_SUCCESS]: (state, payload) => {
      console.log('payload web pages', payload);
      return {
        ...state,
        list: payload.WEB_PAGES.data || [],
        loading: false,
        error: null,
      };
    },
    [WEB_PAGES_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_PAGES_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_PAGES_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      error: null,
      deleted: true,
    }),
    [WEB_PAGES_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_PAGES_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [WEB_PAGES_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_PAGES_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.concat(payload.informationCategory),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [WEB_PAGES_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_PAGES_MODIFY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_PAGES_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: !state.list
        ? []
        : state.list.map((elem) => {
            if (elem._id === payload.id) {
              return {
                _id: payload.id,
                name: payload.informationCategory.name,
                description: payload.informationCategory.description,
                siteId: payload.informationCategory.siteId,
                modifiedAt: new Date().toDateString(),
                modifiedBy: payload.informationCategory.modifiedBy,
              };
            }
            return elem;
          }),
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [WEB_PAGES_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_PAGES_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [WEB_PAGES_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SET_WEB_PAGES]: (state, payload) => ({
      ...state,
      category: payload.data,
    }),
  },
  initialState
);
